import { captureError } from "@core-ui/utils/Error";

const isLocalStorageAvailable = (): boolean => typeof window !== "undefined" && typeof localStorage !== "undefined";

export class LocalStorage {
    public static getItem<T>(key: string, defaultValue?: T, errorCallback?: VoidFunction): T | undefined {
        try {
            if (isLocalStorageAvailable()) {
                const item = window.localStorage.getItem(key);

                return item && item !== "undefined" ? JSON.parse(item) : defaultValue;
            }
            return defaultValue;
        } catch (error) {
            errorCallback?.();
            captureError(error);
            return defaultValue;
        }
    }

    public static setItem<T>(key: string, value: T, errorCallback?: VoidFunction): void {
        try {
            if (isLocalStorageAvailable()) {
                // set item in local storage
                localStorage.setItem(key, JSON.stringify(value));
            }
        } catch (err) {
            errorCallback?.();
            captureError(err);
        }
    }

    static removeItem(key: string): void {
        if (isLocalStorageAvailable()) {
            localStorage.removeItem(key);
        }
    }
}
